import type { ReactNode } from "react";

/**
 * Market Outlook & Journal — its own top-level section, kept SEPARATE from
 * Market Timing.
 *
 * Same move, and the same reason, as Daily Brief and Live Breadth: a page left
 * under `/timing/*` inherits that section's sub-tab bar from
 * `app/timing/layout.tsx`, so once it is out of `TIMING_TABS` it would render
 * under a row of siblings it no longer belongs to. Single page, no sub-tabs.
 */
export default function OutlookLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light w-full px-6 py-2 xl:px-8 2xl:px-10">
      {children}
    </main>
  );
}
